import { useState, useEffect } from "react";
import { db } from "../db/localDB";
import { crearDisentimiento as apiCrearDisentimiento } from "../api/consentimientoAPI";

// ── Estado de conexión (igual patrón que useOnlineStatus en BAC) ────────
export function useOnlineStatus() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const marcarOnline = () => setOnline(true);
    const marcarOffline = () => setOnline(false);
    window.addEventListener("online", marcarOnline);
    window.addEventListener("offline", marcarOffline);
    return () => {
      window.removeEventListener("online", marcarOnline);
      window.removeEventListener("offline", marcarOffline);
    };
  }, []);
  return online;
}

// ── Guardar un disentimiento offline (cuando no se pudo enviar) ─────────
export async function guardarDisentimientoOffline(payload) {
  const localId = await db.disentimiento_pendientes.add({
    ...payload,
    sincronizado: 0,
    createdAt: new Date().toISOString(),
  });
  console.log("💾 Disentimiento guardado offline, localId:", localId);
  return localId;
}

export async function contarDisentimientosPendientes() {
  return db.disentimiento_pendientes.where("sincronizado").equals(0).count();
}

// ── Sincronizar los pendientes — se llama sola al recuperar señal ───────
// El flag evita que dos disparos casi simultáneos (carga de la página +
// evento "online") recorran la cola a la vez. Aun así, si pasara, el
// servidor es idempotente por "codigo" y no duplicaría nada.
let sincronizando = false;
export async function sincronizarDisentimientosPendientes() {
  if (sincronizando) return 0;
  sincronizando = true;
  try {
    const pendientes = await db.disentimiento_pendientes.where("sincronizado").equals(0).toArray();
    let sincronizados = 0;

    for (const r of pendientes) {
      try {
        const { id, sincronizado, createdAt, ...payload } = r;
        await apiCrearDisentimiento(payload);
        // Se borra (no solo se marca) — ya quedó en el servidor, no hay
        // razón para seguir ocupando espacio local (incluye la firma en
        // base64, que es lo que más pesa).
        await db.disentimiento_pendientes.delete(r.id);
        sincronizados++;
      } catch (e) {
        console.error("❌ Error sincronizando disentimiento pendiente:", e.message);
        // Se queda en la cola — se reintenta la próxima vez que haya señal.
      }
    }

    if (sincronizados > 0) {
      console.log(`✅ Sincronizados ${sincronizados} disentimiento(s) pendiente(s)`);
      window.dispatchEvent(new CustomEvent("disentimiento-sync-completado"));
    }
    return sincronizados;
  } finally {
    sincronizando = false;
  }
}

// ── Se dispara sola: al cargar la app, y cada vez que vuelve la señal ──
let yaEscuchando = false;
export function iniciarSincronizacionAutomaticaDisentimiento() {
  if (yaEscuchando) return; // evita registrar el listener más de una vez
  yaEscuchando = true;

  if (navigator.onLine) sincronizarDisentimientosPendientes().catch(() => {});
  window.addEventListener("online", () => {
    sincronizarDisentimientosPendientes().catch(() => {});
  });
}